import { useEffect, useState } from 'react';
import Loader from './Loader';

export default function AppLoader({ onFinish }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFading(true), 2000);
    const finish = setTimeout(() => onFinish(), 2600);
    return () => { clearTimeout(timer); clearTimeout(finish); };
  }, []);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#080608',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 28,
      opacity: fading ? 0 : 1,
      transition: 'opacity 0.6s ease',
      pointerEvents: fading ? 'none' : 'all',
    }}>
      {/* Grain overlay */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none', opacity: 0.3,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
        backgroundSize: '180px',
      }} />

      {/* Logo */}
      <div style={{ textAlign: 'center', marginBottom: 8 }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: 'linear-gradient(135deg, #D4537E, #993556)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24, color: '#fff', margin: '0 auto 16px',
          boxShadow: '0 0 32px rgba(212,83,126,0.4)',
        }}>♪</div>
        <div style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 300, fontSize: 28,
          letterSpacing: '0.2em', color: '#f5e6ed',
          textTransform: 'uppercase',
        }}>Echo Moments</div>
        <div style={{
          fontSize: 10, letterSpacing: '0.25em',
          color: 'rgba(212,83,126,0.6)',
          textTransform: 'uppercase', marginTop: 6,
        }}>That one part everyone needs to hear</div>
      </div>

      {/* Hamster loader */}
      <Loader />
    </div>
  );
}